import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ShopHero from "./components/ShopHero";
import ProductGrid from "./components/ProductGrid";

export default function ShopPage() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <ShopHero />
      <ProductGrid />
      <Footer />
    </div>
  );
}
